import React, { lazy, Suspense } from 'react';
import Login from 'pages/Login';
import Body from 'pages/layout/Body';
import Loading from 'pages/Loading';
import PropTypes from 'prop-types'

const loadPage = async (pagePath) => {
    loadPage.propTypes = {
        pagePath : PropTypes.any,
    }
    let obj = await import(`../${pagePath}`);
        return typeof obj.default === 'function'?obj:obj.default;
}
      
const DevicePage = lazy(() => { return loadPage("pages/device/Management"); });
const DeviceStatus = lazy(() => { return loadPage("pages/device/Status"); });
const AlarmPage = lazy(() => { return loadPage("pages/device/AlarmManagement"); });

const deviceRouter = () => {
    return [
        {
            path:"device",
            element: <Suspense fallback={<Loading/>}><DevicePage /></Suspense>,
            label : "장비 관리", 
        },
        {
            path:"deviceStatus",
            element: <Suspense fallback={<Loading/>}><DeviceStatus /></Suspense>,
            label : "장비 현황", 
        },
        {
            path:"alarm",
            element: <Suspense fallback={<Loading/>}><AlarmPage /></Suspense>,
            label : "알림 관리", 
        },

       
    ];
}

const MainPage = lazy(() => { return loadPage("pages/Main"); });
const ManagementPage = lazy(() => { return loadPage("pages/user/Management"); });
const DepartmentPage = lazy(() => { return loadPage("pages/user/Department"); });
const MyPage = lazy(() => { return loadPage("pages/user/Mypage"); });
  

const adminRouter = () => {
    return [
        {
            index:true,
            path:"",
            element: <Suspense fallback={<Loading/>}><MainPage/></Suspense>,
            label : "메인", 
        },        {
            path:"admin",
            element: <Suspense fallback={<Loading/>}><ManagementPage /></Suspense>,
            label : "관리자 관리", 
        },
        {
            path:"settings",
            element: <Suspense fallback={<Loading/>}><DepartmentPage /></Suspense>,
            label : "부서 설정", 
        },
        {
            path:"mypage",
            element: <Suspense fallback={<Loading/>}><MyPage /></Suspense>,
            label : "마이페이지", 
        },
       
    ];
}
const root = [
    {
        path: "/",
        element: <Login />,
    },
    {
        path: "main",
        element: <Body />,
        children: adminRouter()
    },
    {
        path: "main",
        element: <Body />,
        children: deviceRouter()
    }
];


export default root;
